// Hooks
import { useSelector } from 'react-redux'

// Types
import { State } from 'types'

// Utils
import { DEFAULT_FEATURE_TOGGLES } from '@constants'

export const useFeatureToggle = (featureToggleName: string): boolean => {
  return useSelector<State, boolean>(
    state => state.featureToggles[featureToggleName]?.active || DEFAULT_FEATURE_TOGGLES.includes(featureToggleName),
  )
}
